import React from 'react';

const ForgotIllustration = () => {
  return (
    <div className="w-full h-full flex items-center justify-center p-8">
      <svg
        viewBox="0 0 800 600"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="w-full h-auto max-w-[650px] drop-shadow-2xl"
      >
        <defs>
          <filter id="softShadow" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur in="SourceAlpha" stdDeviation="4" />
            <feOffset dx="0" dy="4" result="offsetblur" />
            <feComponentTransfer>
              <feFuncA type="linear" slope="0.1" />
            </feComponentTransfer>
            <feMerge>
              <feMergeNode />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
          
          <linearGradient id="bgGrad" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#E5FAFF" stopOpacity="0.5" />
            <stop offset="100%" stopColor="#FFFFFF" stopOpacity="0" />
          </linearGradient>

          <linearGradient id="lockGradient" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#1E4387" />
            <stop offset="100%" stopColor="#0BAFD4" />
          </linearGradient>

          <linearGradient id="keyGradient" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#F59E0B" />
            <stop offset="100%" stopColor="#FCD34D" />
          </linearGradient>
          
           <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
            <path d="M 40 0 L 0 0 0 40" fill="none" stroke="#E2E8F0" strokeWidth="0.5" />
          </pattern>
        </defs>

        {/* Background Elements */}
        <circle cx="400" cy="300" r="280" fill="url(#bgGrad)" />
        <rect x="0" y="0" width="800" height="600" fill="url(#grid)" opacity="0.3" />

        {/* Central Element: Security Interface */}
        <g filter="url(#softShadow)">
            <rect x="200" y="150" width="400" height="300" rx="16" fill="white" stroke="#F1F5F9" strokeWidth="2" />
            
            {/* Window Controls */}
            <circle cx="220" cy="170" r="5" fill="#EF4444" opacity="0.8" />
            <circle cx="240" cy="170" r="5" fill="#F59E0B" opacity="0.8" />
            <circle cx="260" cy="170" r="5" fill="#10B981" opacity="0.8" />
            <rect x="280" y="165" width="200" height="10" rx="5" fill="#E2E8F0" opacity="0.5" />

            {/* Input Field Representation */}
            <rect x="250" y="280" width="300" height="40" rx="8" fill="#F8FAFC" stroke="#E2E8F0" />
            <text x="270" y="305" fill="#94A3B8" fontSize="14" fontFamily="sans-serif">Enter your email address...</text>
            <rect x="250" y="340" width="120" height="36" rx="6" fill="#0BAFD4" />
            <text x="310" y="362" fill="white" fontSize="14" fontWeight="bold" textAnchor="middle" fontFamily="sans-serif">Reset</text>

            {/* Lock Icon */}
            <g transform="translate(360, 200)">
                 <path d="M40 0C17.9086 0 0 17.9086 0 40V50H80V40C80 17.9086 62.0914 0 40 0Z" fill="url(#lockGradient)" opacity="0.1" />
                 <path d="M25 20C25 11.7157 31.7157 5 40 5C48.2843 5 55 11.7157 55 20V35H25V20Z" stroke="#0BAFD4" strokeWidth="4" />
                 <rect x="15" y="35" width="50" height="40" rx="4" fill="url(#lockGradient)" />
                 <circle cx="40" cy="55" r="5" fill="white" />
                 <rect x="38" y="55" width="4" height="10" fill="white" />
            </g>
        </g>

        {/* Floating Elements: Question Mark */}
        <g transform="translate(550, 120)" filter="url(#softShadow)">
             <circle cx="30" cy="30" r="30" fill="white" />
             <text x="30" y="42" fill="#0BAFD4" fontSize="36" fontWeight="bold" textAnchor="middle" fontFamily="sans-serif">?</text>
        </g>
        
        {/* Floating Elements: Email Envelope */}
        <g transform="translate(140, 380) rotate(-10)" filter="url(#softShadow)">
            <rect width="100" height="70" rx="8" fill="white" stroke="#E2E8F0" />
            <path d="M0 8L50 40L100 8" stroke="#1E4387" strokeWidth="2" fill="none" />
            <path d="M0 70L40 40" stroke="#E2E8F0" strokeWidth="1" />
            <path d="M100 70L60 40" stroke="#E2E8F0" strokeWidth="1" />
            <circle cx="50" cy="35" r="12" fill="#EFF6FF" />
            <path d="M50 28V42M43 35H57" stroke="#1E4387" strokeWidth="2" strokeLinecap="round" />
        </g>

        {/* Floating Elements: Key */}
        <g transform="translate(600, 400) rotate(15)" filter="url(#softShadow)">
            <path d="M20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0ZM20 12C24.4183 12 28 15.5817 28 20C28 24.4183 24.4183 28 20 28C15.5817 28 12 24.4183 12 20C12 15.5817 15.5817 12 20 12Z" fill="#FEF3C7" />
            <rect x="40" y="15" width="40" height="10" fill="#FEF3C7" />
            <rect x="65" y="15" width="8" height="18" fill="#FEF3C7" />
            <rect x="50" y="15" width="8" height="15" fill="#FEF3C7" />
        </g>

        {/* Connecting Lines */}
        <path d="M190 380 Q 250 350 280 400" stroke="#0BAFD4" strokeWidth="1" strokeDasharray="4 4" opacity="0.4" fill="none" />
        <path d="M580 150 Q 500 200 450 180" stroke="#0BAFD4" strokeWidth="1" strokeDasharray="4 4" opacity="0.4" fill="none" />

      </svg>
    </div>
  );
};

export default ForgotIllustration;
